import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useServiceDrawer } from "./useServiceDrawer";
import { ReportProblem } from "@mui/icons-material";
import { cancelOrder, cancelShipment } from "./orderApi";
import toast from "react-hot-toast";

import { useMessageDialog } from "../../../context/MessageDialogContext";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "6px",
};

const OrderCancelModal = () => {
  const { id, isCancelOrderOpen, onCloseCanel, setSyncOrder } =
    useServiceDrawer();

  const { showMessage } = useMessageDialog();

  const cancelOrderHandler = () => {
    cancelOrder([id as string])
      .then((data) => {
        showMessage("Success","Order cancelled successfully!");
        setSyncOrder();
        onCloseCanel();
      })
      .catch((err) => {
        showMessage("Error","Unable to cancel service");
      });
  };
  const cancelServiceHandler = () => {
    cancelShipment([id as string])
      .then((data) => {
        showMessage("Success","Service cancelled successfully!");
        setSyncOrder();
        onCloseCanel();
      })
      .catch((err) => {
        console.log(err);
        showMessage("Error","Unable to cancel order");
      });
  };

  return (
    <Modal open={isCancelOrderOpen} onClose={onCloseCanel}>
      <Box sx={style}>
        {/* <div>{id}</div> */}
        <Stack
          justifyContent={"space-between"}
          direction={"column"}
          sx={{
            minHeight: "200px",
          }}
        >
          <Stack justifyContent={"center"} alignItems={"center"}>
            <ReportProblem
              sx={{
                fontSize: "80px",
                color: "red",
              }}
            />
            <Typography textAlign={"center"}>
              Are you sure you want to cancel this order?
            </Typography>
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"8px"}
          >
            <Button
              onClick={onCloseCanel}
              size="small"
              sx={{
                textTransform: "none",
              }}
              variant="outlined"
            >
              Don't Cancel
            </Button>
            <Button
              size="small"
              sx={{
                textTransform: "none",
                bgcolor: "red",
                ":hover": {
                  bgcolor: "#ff0000cc",
                },
              }}
              variant="contained"
              onClick={cancelServiceHandler}
            >
              Cancel Service
            </Button>
            <Button
              size="small"
              sx={{
                textTransform: "none",
                bgcolor: "red",
                ":hover": {
                  bgcolor: "#ff0000cc",
                },
              }}
              variant="contained"
              onClick={cancelOrderHandler}
            >
              Cancel Order
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
};

export default OrderCancelModal;
